export default __webpack_public_path__ + "static/media/file-save.6d06e529.png";